export const endpoint = {
  base: {
    enum: "/enum",
    city_state: "/state-cities",
    send_otp: "/otp",
    verify_otp: "/otp/verify",
    upload_file: "/upload-file",
  },
  institute: {
    enum: "/enum",
    register: "/register",
  },
  subscriptions: {
    plans: "/plans",
    executiveCode: "/plans/executive-code",
    discountCode: "/plans/discount-code",
  }
};
